import * as countryActionTypes from "./countryActionTypes";
import { hideSpinner, showSpinner } from "../spinner/spinnerActions";
import { publishMessage } from "../notification/notificationActions";
import { clearChangeLogs, loadChangeLogs } from "../changelog/changeLogActions";
import Axios from "axios";
import { baseUrl } from "../../util/host";

export const setCountryList = (countryList) => {
  return {
    type: countryActionTypes.LOAD_COUNTRY,
    value: countryList,
  };
};

export const fetchCountryListFailed = (error) => {
  return {
    type: countryActionTypes.LOAD_COUNTRY_FAILED,
    value: error,
  };
};

export const loadCountry = () => {
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/find/country`)
      .then((res) => {
        dispatch(setCountryList(res.data.response));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(fetchCountryListFailed(err));
        dispatch(hideSpinner());
      });
  };
};

export const addCountry = (country) => {
  return {
    type: countryActionTypes.ADD_COUNTRY,
    value: country,
  };
};

export const publishCountry = () => {
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/publish`)
      .then((res) => {
        dispatch(hideSpinner());
        dispatch(
          publishMessage({
            message: `Publish has been initiated successfully with job id <a href="/jobs/activity">${res.data.jobId}</a> `,
            severity: "success",
          })
        );
        dispatch(clearChangeLogs());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const updateCutOffTime = async (time, title, type) => {
  return (dispatch) => {
    if (type === "day")
      time = time.join(",").replace(/(^[,\s]+)|([,\s]+$)/g, "");
    const payload = { title: title, type_data: time, type: type };
    dispatch(showSpinner());
    Axios.put(`${baseUrl("REACT_APP_API_URL")}/api/address/cutofftime`, payload)
      .then((res) => {
        dispatch({
          type: countryActionTypes.UPDATE_CUTOFF_TIME,
          value: payload,
        });
        dispatch(hideSpinner());
        dispatch(loadChangeLogs());
      })
      .catch((err) => {
        dispatch(hideSpinner());
        console.log(err);
      });
  };
};

export const setCentralWarehouses = (warehouses) => {
  return {
    type: countryActionTypes.LOAD_CENTRAL_WAREHOUSES,
    value: warehouses,
  };
};

export const fetchCentralWarehousesFailed = (error) => {
  return {
    type: countryActionTypes.LOAD_CENTRAL_WAREHOUSES_FAILED,
    value: error,
  };
};

export const loadCentralWarehouses = () => {
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(`${baseUrl("REACT_APP_API_URL")}/api/address/central-fulfillment-centers`)
      .then((res) => {
        const warehouses = (res.data.data || []).filter(w => w.status === true);
      
        dispatch(setCentralWarehouses(warehouses));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.error('Error fetching central warehouses:', err);
        dispatch(fetchCentralWarehousesFailed(err));
        dispatch(hideSpinner());
      });
  };
};

export const setSelectedWarehouse = (warehouse) => {
  return {
    type: countryActionTypes.SET_SELECTED_WAREHOUSE,
    value: warehouse,
  };
};

export const setCountries = (countries) => {
  return {
    type: countryActionTypes.LOAD_COUNTRIES,
    value: countries,
  };
};

export const fetchCountriesFailed = (error) => {
  return {
    type: countryActionTypes.LOAD_COUNTRIES_FAILED,
    value: error,
  };
};

export const loadCountries = () => {
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(`${baseUrl("REACT_APP_API_URL")}/api/address/countries`)
      .then((res) => {
        dispatch(setCountries(res.data.data || []));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.error('Error fetching countries:', err);
        dispatch(fetchCountriesFailed(err));
        dispatch(hideSpinner());
      });
  };
};

export const setWhCountryMappings = (mappings) => {
  return {
    type: countryActionTypes.LOAD_WH_COUNTRY_MAPPINGS,
    value: mappings,
  };
};

export const fetchWhCountryMappingsFailed = (error) => {
  return {
    type: countryActionTypes.LOAD_WH_COUNTRY_MAPPINGS_FAILED,
    value: error,
  };
};

export const loadWhCountryMappings = () => {
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.get(`${baseUrl("REACT_APP_API_URL")}/api/address/warehouse-country-mappings`)
      .then((res) => {
        const data = res.data.data || [];
        const map = new Map();
        for(const d of data) {
          map.set(d.warehouse, d.countries);
        }
        dispatch(setWhCountryMappings(map));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.error('Error fetching warehouse-country mappings:', err);
        dispatch(fetchWhCountryMappingsFailed(err));
        dispatch(hideSpinner());
      });
  };
};

export const updateWhCountryMappings = (warehouse, countries) => {
  return {
    type: countryActionTypes.UPDATE_WH_COUNTRY_MAPPINGS,
    value: { warehouse, countries },
  };
};
